module.exports = __webpack_public_path__ + "static/media/599.767(18).c92f2d4d.pdf";